module.exports = __webpack_public_path__ + "static/img/pfriemsters_join_us.175bd7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pfriemsters_join_us.png
// module id = 71
// module chunks = 1